import { apiRequest } from "./apiClient";
import { sanitizeFormValues } from "@utils/sanitize";

export const fetchAgentPurposes = async () => {
  return await apiRequest({
    method: "GET",
    endpoint: "/agent-question/agent-purposes",
  });
};

/**
 * ---------------------------
 * Agent Question Library
 * ---------------------------
 */

export const fetchAgentQuestions = async () => {
  return await apiRequest({
    method: "GET",
    endpoint: "/agent-question/agent-questions",
  });
};

export const createAgentQuestion = async (payload) => {
  return await apiRequest({
    method: "POST",
    endpoint: "/agent-question/agent-questions",
    body: payload,
  });
};

export const updateAgentQuestion = async (questionEnum, payload) => {
  return await apiRequest({
    method: "PATCH",
    endpoint: `/agent-question/agent-questions/${encodeURIComponent(questionEnum)}`,
    body: payload,
  });
};

export const deleteAgentQuestion = async (questionEnum) => {
  return await apiRequest({
    method: "DELETE",
    endpoint: `/agent-question/agent-questions/${encodeURIComponent(questionEnum)}`,
  });
};

/**
 * ---------------------------
 * Default Agent Question Flows
 * ---------------------------
 */

export const fetchDefaultAgentQuestions = async ({ purpose }) => {
  return await apiRequest({
    method: "GET",
    endpoint: `/agent-question/default-agent-questions?purpose=${encodeURIComponent(
      purpose,
    )}`,
  });
};

export const saveDefaultAgentQuestions = async ({ purpose, items }) => {
  return await apiRequest({
    method: "PUT",
    endpoint: `/agent-question/default-agent-questions?purpose=${encodeURIComponent(
      purpose,
    )}`,
    body: { items },
  });
};

export const fetchClinicAgentQuestionsAll = async (clinicId) => {
  return apiRequest({
    method: "GET",
    endpoint: `/agent-question/clinic-agent-questions/all?clinic_id=${encodeURIComponent(
      clinicId,
    )}`,
  });
};

export const saveClinicAgentQuestionsAll = async (clinicId, byPurpose) => {
  return apiRequest({
    method: "PUT",
    endpoint: `/agent-question/clinic-agent-questions/all?clinic_id=${encodeURIComponent(
      clinicId,
    )}`,
    body: sanitizeFormValues({ by_purpose: byPurpose }),
  });
};
